/*
 * @Author: wufan
 * @Date: 2020-07-23 17:56:54
 * @Last Modified by: wufan
 * @Last Modified time: 2020-08-11 17:14:43
 * 微官网太阳码
 */

 <template>
  <div class="micro-site-modal"  v-transfer-dom>
    <div class="micro-site-modal" v-if="!data.fromOrigin">
      <div class="micro-site-modal-content">
        <div class="code-box">
          <div class="top-text">
            <p>长按识别下方小程序码</p>
            <p>查看机构微官网，获取更多优惠福利</p>
          </div>
          <img :src="data.currentXcxCodeUrl" alt />
        </div>
        <div class="inst-desc">
          <div
            class="inst-name-address-logo"
            v-if="data.currentItem.address && (data.currentItem.banner)"
          >
            <img :src="data.currentItem.banner" alt />
            <div class="institution-address-logo-box">
              <div class="institution-name mh-name">{{this.getString(data.currentItem.name,39)}}</div>
              <div class="institution-address mh-address">{{this.getString(data.currentItem.address,38)}}</div>
            </div>
          </div>
          <div
            class="inst-name-address"
            v-if="data.currentItem.address && !(data.currentItem.banner)"
          >
            <img src="https://image.xiaomaiketang.com/xm/rF7ewNtpTC.png" alt>
            <div class="institution-address-logo-box">
              <div class="institution-name mh-name">{{this.getString(data.currentItem.name,39)}}</div>
              <div class="institution-address mh-address">{{this.getString(data.currentItem.address,38)}}</div>
            </div>

          </div>
          <div class="inst-name-logo" v-if="(data.currentItem.banner) && !data.currentItem.address">
            <img :src="data.currentItem.banner" alt />
            <div class="institution-name">{{data.currentItem.name}}</div>
          </div>
          <div
            class="inst-name"
            v-if="data.currentItem.name && (!data.currentItem.banner&& !data.currentItem.address)"
          >
            <img src="https://image.xiaomaiketang.com/xm/rF7ewNtpTC.png" alt>
            <div class="institution-name">{{data.currentItem.name}}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="product-micro-site"
      v-if="data.fromOrigin === 'product-list' || data.fromOrigin === 'h5-coupon'"
    >
      <div class="micro-site-modal-content">
        <div class="code-box">
          <div class="top-text text-left" v-if="data.fromOrigin === 'h5-coupon'">
            <p>1.截图保存下方小程序码</p>
            <p>2.打开微信扫描小程序码，查看机构微官网，获取更多优惠福利</p>
          </div>
          <div class="top-text" v-if="data.fromOrigin === 'product-list'">
            <p>长按识别下方小程序码</p>
            <p>查看机构微官网，获取更多优惠福利</p>
          </div>
          <img :src="data.currentXcxCodeUrl" alt />
        </div>
        <div class="close-icon" @click="data.close">
          <img src="https://image.xiaomaiketang.com/xm/tsPzbNMe4M.png" alt />
        </div>
      </div>
    </div>

    <!-- <img
      class="xm-poster-canvas"
      :class="data.fromOrigin ? 'product-micro-canvas' : 'micro-site-canvas'"
      :src="posterCanvasUrl"
    /> -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  props: ["data"],
  data() {
    return {
      posterCanvasUrl: ""
    }
  },
  mounted() {
    this.createCanvas();
  },
  methods: {
    createCanvas() {
        const dom = document.querySelector(
          `.${this.data.fromOrigin ? "product-micro-site" : "micro-site-modal"}`
        );
        html2canvas(dom, {
          useCORS: true,
          allowTaint: false
        }).then(canvas => {
          this.posterCanvasUrl = canvas.toDataURL();
        });
    },

    getString(str,num){
      if(str.length > num){
        return `${str.substring(0,num-1)}...`
      }
      return str.substring(0,num);
    }
  }
};
</script>

<style lang="less">
.product-micro-site {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3000;
  .micro-site-modal-content {
    width: 6.8rem;
    height: 6rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    position: relative;
    margin: 1.46rem auto;
    .code-box {
      .top-text {
        margin-bottom: 0.04rem;
        padding-top: 0.6rem;
        &.text-left {
          text-align: left;
          padding-left: 0.4rem;
          padding-right: 0.4rem;
        }
      }
      img {
        width: 3.6rem;
        height: 3.6rem;
        margin: 0 auto;
      }
    }
    .close-icon {
      top: 10rem;
      position: absolute;
      width: 0.48rem;
      height: 0.48rem;
      top: 7rem;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 0.48rem;
        height: 0.48rem;
        z-index: 30000;
      }
    }
  }
}
.product-micro-canvas {
  width: 6.8rem;
  height: 6rem;
  z-index: 3001;
  position: fixed;
  left: 18px;
  top: 73px;
  opacity: 0;
}
.micro-site-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(224, 237, 255, 1);
  z-index: 300;
  .micro-site-modal-content {
    width: 6.8rem;
    height: 7.8rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin: 40px auto;
    padding: 0.6rem;
    .code-box {
      text-align: center;
      border-bottom: 1px dashed rgba(232, 232, 232, 1);
      .top-text {
        margin-bottom: 0.04rem;
      }
      img {
        width: 3.6rem;
        height: 3.6rem;
        margin: 0 auto;
      }
    }
    .inst-desc {
      margin-top: 0.3rem;
      text-align: left;
      .inst-name-address-logo {
        display: flex;
        img {
          width: 0.88rem;
          height: 0.88rem;
          min-width: 0.88rem;
        }
        .institution-address-logo-box {
          margin-left: 0.16rem;
          .institution-name {
            min-height: 0.48rem;
            font-size: 0.34rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(57, 70, 85, 1);
            line-height: 0.48rem;
          }
          .mh-name{
            max-height: 1.44rem;
            text-overflow: ellipsis;
            white-space: pre-line;
            overflow: hidden;
          }
          .institution-address {
            min-height: 0.32rem;
            font-size: 0.22rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(150, 161, 174, 1);
            line-height: 0.32rem;
            margin-top: 0.06rem;
          }
          .mh-address{
            max-height: 0.64rem;
            overflow: hidden;
          }
        }
      }
      .inst-name-logo {
        display: flex;
        align-items: center;
        img {
          width: 0.88rem;
          height: 0.88rem;
        }
        .institution-name {
          margin-left: 0.16rem;
          height: 0.48rem;
          font-size: 0.34rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(57, 70, 85, 1);
          line-height: 0.48rem;
        }
      }

      .inst-name-address {
        display: flex;
        align-items: center;
        img {
          width: 0.88rem;
          height: 0.88rem;
          min-width: 0.88rem;
        }
        .institution-address-logo-box {
          margin-left: 0.16rem;

          .institution-name {
            min-height: 0.48rem;
            font-size: 0.34rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(57, 70, 85, 1);
            line-height: 0.48rem;
          }
          .institution-address {
            min-height: 0.32rem;
            font-size: 0.22ren;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(150, 161, 174, 1);
            line-height: 0.32rem;
            margin-top: 0.06rem;
          }
          .mh-name{
            max-height: 1.44rem;
            text-overflow: ellipsis;
            white-space: pre-line;
            overflow: hidden;
          }

          .mh-address{
            max-height: 0.64rem;
            overflow: hidden;
          }
        }
      }
      .inst-name {
        display: flex;
        flex-direction: row;
        img {
          width: 0.88rem;
          height: 0.88rem;
          min-width: 0.88rem;
          margin-right: 0.16rem;
        }
        .institution-name {
          height: 0.48rem;
          font-size: 0.34rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(57, 70, 85, 1);
          line-height: 0.48rem;
        }
      }
    }
  }
}
.micro-site-canvas {
    width: 6.8rem;
    height: 7.8rem;
    background: transparent;
    z-index: 3001;
    position: fixed;
    top: 40px;
    left: 18px;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MicroSiteModal.vue